import { Helmet } from "react-helmet-async";

const SITE_NAME = "myFLOVEA";
const SITE_URL = "https://comfort-tech-shop.emergent.host";

/**
 * Per-page SEO component (title + description + canonical + OG).
 * `path` should be the route path without the origin (e.g. "/faq").
 */
const Seo = ({ title, description, path = "", image, lang = "fr" }) => {
  const alreadyBranded = title && title.toLowerCase().includes(SITE_NAME.toLowerCase());
  const fullTitle = title
    ? (alreadyBranded ? title : `${title} | ${SITE_NAME}`)
    : `${SITE_NAME} — Le confort qui te suit partout`;
  const desc =
    description ||
    "myFLOVEA — Le confort qui te suit partout. Coussin Massant Chauffant premium, expédié depuis l'Europe (Allemagne), livré en 3 à 7 jours ouvrés.";
  const url = `${SITE_URL}${path}`;
  const ogImage = image || `${SITE_URL}/og-cover.jpg`;

  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={lang === "fr" ? "fr_FR" : "en_US"} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default Seo;
